import React, { Fragment } from 'react'
import I18n from 'i18n-react'
import Images from '../../../Themes/Images'
//components
import SuriIndex from '../_helpComponents/SuriIndex'
// types
import type { ColumnTypeDefaultProps } from './ColumnTypeDefault'

type ColumnTypeSuriIndexState = {
  pushOpen: boolean,
}

export default class ColumnTypeSuriIndexPillow extends React.Component<
  ColumnTypeDefaultProps,
  ColumnTypeSuriIndexState,
> {
  state = {
    pushOpen: false,
  }

  onClose = () => {
    this.setState({ pushOpen: false })
  }

  handleOpenModal = () => {
    this.setState({ pushOpen: true })
  }

  render = () => {
    const elementId = `quote-insuranceCompany-suri-index-${this.props.columnConfig.key}-${this.props.quote.id}`
    return (
      <Fragment>
        <div
          className={this.props.columnConfig.classNames.wrapper}
          id={elementId}
          key={elementId}
          onClick={this.handleOpenModal}
        >
          <div className={this.props.columnConfig.classNames.valueWrapper}>
            <strong className={this.props.columnConfig.classNames.value}>?</strong>
            <img
              alt="Suri index"
              className={this.props.columnConfig.classNames.image}
              src={Images.suriIndexImage}
              width="30"
            />
          </div>
          <div className={this.props.columnConfig.classNames.priceWrapper}>
            <p>
              <strong>{I18n.translate(`suriIndex.experiences.title`)}</strong>
            </p>
          </div>
        </div>
        <SuriIndex hideButton={true} onClose={this.onClose} pushOpen={this.state.pushOpen} target={`${elementId}`} />
      </Fragment>
    )
  }
}
